import {nextTick} from 'vue';
import {createRouter, createWebHistory} from 'vue-router';

//Import Views.
import Find from './views/Find';
import Payment from './views/Payment';
import Trip from './views/Trip';

const routes = [
    {
        path: '/',
        name: 'find',
        component: Find,
        meta: {
            title: 'Find My Trip' //TODO translate me.
        }
    },
    {
        path: '/:tripId/:linkId/:linkTinyHash',
        name: 'payment',
        component: Payment,
        meta: {
            title: 'Payment' //TODO translate me.
        }
    },
    {
        path: '/trip/:tripId/:tripTinyHash/:targetLinkId?', //Optional target link ID, for the purposes of showing contextual link status info, such as if the link is expired or has been completed.
        name: 'trip',
        component: Trip,
        meta: {
            title: 'My Trip' //TODO translate me.
        }
    }
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            //Return to the saved position, if set.
            return savedPosition;
        } else {
            //Otherwise scroll to the top of the page.
            return { top: 0 }
        }
    },
    routes
});

const defaultTitle = 'Pay For My Trip';
router.afterEach((to) => {
    // Use next tick to handle router history correctly
    // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
    nextTick(() => {
        document.title = to.meta.title ? to.meta.title + ' • ' + defaultTitle : defaultTitle;
    });
});


export default router;
